export enum SystemEventFields {
    ID = "id",
    PARENT_ID = "parentId",
    PARENT_TYPE = "parentType",
    USER_ID = "userId",
    EVENT_TYPE = "eventType",
    META_DATA = "metaData",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
}
